import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Users } from 'lucide-react';

/**
 * Ministry Enrollments (admin view) modal — extracted from App.js HomePage.
 * Lists every person who has enrolled in a specific ministry.
 */
const MinistryEnrollmentsAdminModal = ({ open, enrollments, onClose }) => (
  <AnimatePresence>
    {open && (
      <div
        data-testid="ministry-enrollments-admin-modal"
        className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-0 sm:p-4"
      >
        <motion.div
          className="bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl w-full sm:max-w-2xl max-h-[90vh] sm:max-h-[80vh] overflow-hidden"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
        >
          <div className="p-4 sm:p-6 border-b border-slate-200">
            <div className="flex items-center justify-between">
              <h3 className="text-xl sm:text-2xl font-bold text-purple-900">
                Ministry Enrollments
              </h3>
              <button
                onClick={onClose}
                data-testid="ministry-enrollments-admin-close"
                className="p-2 rounded-xl hover:bg-slate-100 transition-colors"
              >
                <X className="w-6 h-6 text-slate-600" />
              </button>
            </div>
          </div>

          <div className="overflow-y-auto max-h-[calc(80vh-120px)] p-6">
            {(enrollments || []).length === 0 ? (
              <div className="text-center py-12">
                <Users className="w-16 h-16 text-slate-400 mx-auto mb-4" />
                <p className="text-slate-600">No enrollments yet</p>
              </div>
            ) : (
              <div className="space-y-3">
                {enrollments.map((enrollment, index) => (
                  <motion.div
                    key={enrollment.id}
                    className="p-4 rounded-xl bg-purple-50 border border-purple-200"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <div>
                      <h4 className="font-semibold text-purple-900">
                        {enrollment.member_name}
                      </h4>
                      <p className="text-sm text-slate-600">{enrollment.member_phone}</p>
                      {enrollment.member_email && (
                        <p className="text-sm text-slate-600">{enrollment.member_email}</p>
                      )}
                      <p className="text-xs text-slate-500 mt-1">
                        Enrolled: {new Date(enrollment.enrolled_at).toLocaleDateString()}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default MinistryEnrollmentsAdminModal;
